import { OfferStatus } from '@synergy/models';

const translationObject: { [Key in OfferStatus]: string } = {
    [OfferStatus.Accepted]: 'app.offerStatus.accepted',
    [OfferStatus.Created]: 'app.offerStatus.created',
    [OfferStatus.Declined]: 'app.offerStatus.declined',
    [OfferStatus.Pending]: 'app.offerStatus.pending',
};

export const getOfferStatusTranslationId = (status?: OfferStatus): string => {
    return (status && translationObject[status]) || 'app.offerStatus.new';
};
